/**
 * Created by Oleg on 28/12/18
 */

const Subscription = function () {
    cleverapps.EventEmitter.call(this);

    this.active = false;
    this.rewardTime = 0;
    this.tokens = {};

    this.updateInfo(cleverapps.dataLoader.load(DataLoader.TYPES.SUBSCRIPTION) || {}, false);

    this.reload();
    cleverapps.gameManager.on("resume", () => this.reload());

    connector.payments.on("subscriptionTokensLoaded", this.addPurchaseTokens.bind(this));
};

Subscription.prototype = Object.create(cleverapps.EventEmitter.prototype);
Subscription.prototype.constructor = Subscription;

Subscription.prototype.getInfo = function (toServer) {
    const sourceData = {
        active: this.active,
        rewardTime: this.rewardTime,
        tokens: this.tokens
    };

    if (toServer && connector.platform.oneOf(connector.IOS, connector.MACOS)) {
        delete sourceData.tokens;
    }

    const data = {};
    data[connector.info.source] = sourceData;
    return data;
};

Subscription.prototype.updateInfo = function (data, fromServer) {
    const source = connector.info.source;
    data = data && data[source];
    if (data) {
        this.active = Boolean(data.id) || data.active;
        this.rewardTime = data.rewardTime || data.lastRewardTime || 0;
        this.tokens = cleverapps.override({}, data.tokens || {}, this.tokens);

        this.save(fromServer);

        this.trigger("update");
    }
};

Subscription.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.SUBSCRIPTION, this.getInfo());

    if (!fromServer) {
        connector.synchronizer.addSendTask("subscription");
    }
};

Subscription.prototype.getLeftTime = function () {
    if (!this.isActive()) {
        return;
    }

    return Math.max(this.rewardTime + cleverapps.parseInterval(Subscription.REWARD_INTERVAL) - Date.now(), 0);
};

Subscription.prototype.scheduleReload = function () {
    clearTimeout(this.reloadTimeout);
    this.reloadTimeout = new cleverapps.LongTimeout(this.reload.bind(this), cleverapps.parseInterval(Subscription.RELOAD_INTERVAL));
};

Subscription.prototype.reload = function () {
    this.scheduleReload();

    if (connector.platform.oneOf(connector.CLEVERAPPS) && !cleverapps.config.debugMode && this.active) {
        this.active = false;
        this.save();
        this.trigger("update");
    }

    if (!Subscription.IsAvailable() || connector.platform.oneOf(connector.TEST) || connector.platform.oneOf(connector.CLEVERAPPS)) {
        return;
    }

    connector.payments.getSubscriptionStatus({ tokens: this.tokens }, (data) => {
        if (data && data.error) {
            return;
        }

        const oldActive = this.isActive();

        // console.log("subscription - " + JSON.stringify(data));
        this.active = data && data.active;

        this.save();
        this.trigger("update");

        if (oldActive && !this.isActive()) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.SUBSCRIPTION_CANCELLED);
        }
    });
};

Subscription.prototype.buy = function (product, callback) {
    const onSuccess = function (success) {
        if (!success) {
            return;
        }

        if (connector.platform.oneOf(connector.IOS, connector.MACOS, connector.ANDROID)) {
            Subscription.BUY_RELOADS.forEach(function (timeout) {
                new cleverapps.LongTimeout(this.reload.bind(this), cleverapps.parseInterval(timeout));
            }, this);
        }
        this.scheduleReload();

        this.active = true;
        this.rewardTime = 0;
        this.save();

        this.trigger("update");
        this.receiveReward();

        callback();
    }.bind(this);

    if (connector.platform.oneOf(connector.CLEVERAPPS)) {
        onSuccess(cleverapps.config.debugMode);
    } else {
        product.buy(onSuccess);
    }
};

Subscription.prototype.addPurchaseTokens = function (purchases, restore) {
    if (!Array.isArray(purchases)) {
        purchases = [purchases];
    }

    let changed = false;
    purchases.forEach((purchase) => {
        const name = purchase.name;
        const purchaseToken = purchase.purchaseToken;
        const productId = purchase.productId;
        const packageName = purchase.packageName;

        const current = this.tokens[name] || {};

        if (name && purchaseToken && productId && packageName
            && (current.purchaseToken !== purchaseToken || current.productId !== productId
                || current.packageName !== packageName)) {
            this.tokens[name] = {
                productId,
                packageName,
                purchaseToken
            };
            changed = true;
        }
    });

    if (changed) {
        if (restore && !this.isActive()) {
            this.lastReloadTime = 0;
            this.reload();
        }
        this.save();
    }
};

Subscription.prototype.isRewardReady = function () {
    return this.getLeftTime() === 0;
};

Subscription.prototype.needsAttention = function () {
    return this.isRewardReady();
};

Subscription.CalcReward = function () {
    const instantRewards = connector.info.source === "instant" && RewardsConfig.SubscriptionInstant;
    const reward = cleverapps.clone(instantRewards || RewardsConfig.Subscription, true);
    return cleverapps.user.setRandomBoostersReward(reward);
};

Subscription.prototype.receiveReward = function () {
    if (!this.isRewardReady()) {
        return;
    }

    const reward = Subscription.CalcReward();

    if (reward.unit) {
        let left = -Map2d.currentMap.countEmptySlots();
        cleverapps.toArray(reward.unit).forEach((unit) => {
            left += unit.amount;
        });

        if (left > 0) {
            cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left }));
            return;
        }
    }

    cleverapps.focusManager.display({
        focus: "SubscriptionReward",
        stack: true,
        action: (f) => {
            new RewardWindow(reward, {
                title: Messages.get("SubscriptionRewardWindow.title"),
                name: "subscriptionrewardwindow",
                text: Messages.get("SubscriptionRewardWindow.subtitle"),
                toMainWorld: !cleverapps.meta.getSelectedLocation().locationConfig.isMain,
                event: cleverapps.EVENTS.EARN.PURCHASE
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });

    this.rewardTime = Date.now();

    this.save();
    this.trigger("update");

    cleverapps.metrics.logEvent(cleverapps.EVENTS.SUBSCRIPTION_REWARD);
};
if (cleverapps.config.debugMode) {
    Subscription.prototype.reset = function () {
        this.active = false;
        this.rewardTime = 0;
        this.tokens = {};
        this.save();
    };
}

Subscription.prototype.isActive = function () {
    return this.active;
};

Subscription.prototype.needDisplayWindow = function () {
    return Subscription.IsAvailable() && !this.isActive();
};

Subscription.IsAvailable = function () {
    if (!Product.CreateById("subsWeek") || !Product.CreateById("subsMonth")) {
        return false;
    }

    if (cleverapps.subscription && cleverapps.subscription.isActive()) {
        return true;
    }

    if (!connector.payments.isSubscriptionsAvailable) {
        return false;
    }

    return cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR && cleverapps.user.checkAvailable(cleverapps.config.availables.SUBSCRIPTION);
};

Subscription.REWARD_INTERVAL = "24 hours";
Subscription.RELOAD_INTERVAL = "30 minutes";
Subscription.BUY_RELOADS = ["1 minute", "3 minutes", "5 minutes", "10 minutes"];

if (cleverapps.config.debugMode) {
    Subscription.REWARD_INTERVAL = "20 minutes";
    Subscription.RELOAD_INTERVAL = "10 minutes";
    Subscription.BUY_RELOADS = ["5 seconds", "10 seconds", "15 seconds", "20 seconds", "30 seconds", "40 seconds"];
}
